import { Card } from "../components/Card";
import { PageHeader } from "../components/PageHeader";
import { methodologySteps } from "../lib/constants";

export function Methodology() {
  return (
    <>
      <PageHeader
        eyebrow="منهجية العمل"
        title="ست خطوات لضبط النطاق وإصدار رأي هندسي قابل للاعتماد"
        description="تبدأ المنهجية بالاستلام وتحديد النطاق، وتنتهي بالدعم اللاحق وإدارة التنفيذ عند الحاجة."
      />
      <section className="py-20">
        <div className="container grid gap-5">
          {methodologySteps.map((step, index) => (
            <Card key={step.title}>
              <div className="grid gap-5 md:grid-cols-[120px_1fr] md:items-center">
                <span className="text-5xl font-bold text-gold">
                  {String(index + 1).padStart(2, "0")}
                </span>
                <div>
                  <h2 className="text-2xl font-bold text-charcoal">{step.title}</h2>
                  <p className="mt-2 leading-8 text-ash">{step.description}</p>
                </div>
              </div>
            </Card>
          ))}
        </div>
      </section>
    </>
  );
}
